import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("PRO_FIELD/LOAD_ALL");
